const state = {
	token: '', // 令牌
	permissions: [] // 权限
}

export default state